const str2date = (dateString) => {
  if (!dateString) return null;
  if (typeof dateString == "string") {
    const [datePart, timePart] = dateString.split(" ");
    const [year, month, day] = datePart.split("/");
    const [hours, minutes, seconds] = timePart ? timePart.split(":") : [0,0,0];
    return new Date(year,month-1,day,hours,minutes,seconds);
  }
  return dateString;
};
export default str2date;
